import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APITemplateService } from '../../_services/template/API-template'; 
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants'; 
import { Router, ActivatedRoute } from '@angular/router';    //cstlinkdelinkfn 


@Component({
  selector: 'app-non-ttl-templates',
  templateUrl: './non-ttl-templates.component.html',
  styleUrls: ['./non-ttl-templates.component.css']
})
export class NonTTLTemplatesComponent implements OnInit {

  maxDate: Date = new Date();
  
  fileDownload: any = [];
  bookmarkArray: any = [""];

  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['peid','urn','cli' ,'tname', 'coty', 'vars','ctgr', 'tcont','cstid','sts'];
  /*  'Uploaded By', */
  form1: any = {};
  fetchedData: any;
  data: any = {};
  noRecord: any;
  bookmark :any="";
  pageIndex:number=1;
  fdate:any;
  ldate:any;
  filterType:string="all";
  param:any;
  operation:string="default";
  counts: any;
  floredvalue: number;
  textField: string;
  entityId:any;
  
  industry_type:any;
  entity_name:any;
  islink: boolean = true     //cstlinkdelinkfn

  onSubmitFilter(filterForm) {


    if (filterForm.searchBy=="Operator")    
    this.param = filterForm.searchBy2
   else
   this.param = filterForm.search


    if (typeof this.param === 'undefined' || this.param == null)
    this.param = "";



    if (filterForm.searchBy)
    this.filterType = filterForm.searchBy; 
    if( !filterForm.search && !filterForm.searchBy){
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please search by valid criteria'
      });
    }
    else if ((this.filterType != null && this.filterType != "") && (this.param == null || this.param=="")) {

      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please provide '+this.textField+' value'
      });
    }
   else if ((this.filterType == null || this.filterType == "") || (this.param == null || this.param=="")) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
   
    else {
      this.searchFunction()
    }
  }
  //cstlinkdelinkfn 
  
  linkFn(CSTempID,commtype,Refno) {	
  
	if(CSTempID != "")
		 this.islink= false
	else
		 this.islink= true
	 //to convert urn to tempid
	 console.log("------------------------islink-------------",this.islink);
	 console.log("------------------------CSTempID-------------",CSTempID);
	
	var TempID = Refno;
	
	  this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.entityId);
	  this.db.set(Constants.SESSSION_STORAGE, Constants.CONSENTTEMPLATEID, CSTempID);
	  this.db.set(Constants.SESSSION_STORAGE, Constants.MODEOFCOMMUNICATION, commtype);
	  this.db.set(Constants.SESSSION_STORAGE, Constants.TM_ID, TempID);
	  this.db.set(Constants.SESSSION_STORAGE, Constants.CSTLINKDELINK, this.islink);
		  
	  this.router.navigate(['linking_consent']);
    }  


searchFunction(){
  this.data = {
    "filterType": this.filterType,
    "param":this.param,
    "peid":this.entityId
  }
  this.ts.searchNonTTLTemplates(this.data)
    .subscribe(r => {
        this.onChangeDataSource(r.templates);
    });
}
  onChangeDataSource(value) {
    this.dataSubject.next(value);
    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator;
    console.log("dataSource : ", this.dataSource);
  }

  public Entity_ID: any;
  applyFilter(filterValue: string) {
    console.log("in filter");
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  dataSource: any;

  form: any = {};
  showDropdown: boolean = false
  startDate1: any;
  
  
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private ts: APITemplateService,
    private db: $DBManagerService,
    private fb: FormBuilder,
	private router: Router, //cstlinkdelinkfn
    private $modal: $ModalManagerService,
  ) {


  }

  ngOnInit() {
    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);

    this.getEntityDetails();
    this.APIgetCTSummary();
    // this.dataSource.sort = this.sort;
   
    console.log(this.startDate1)
    this.maxDate.setDate(new Date().getDate());

  }
  APIgetCTSummary() {
    var data={
      peid: this.entityId
    }
  
    this.ts.getnonTTLTemplates(data).subscribe({
      next: value => {
     
        this.counts = value.count
        this.floredvalue = Math.ceil(this.counts / 10)
        this.dataSubject.next(value);
        this.bookmark = value.bookmark
        this.dataSource = new MatTableDataSource(value.templates);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        console.log("dataSource : ", this.dataSource);
      }
    });
  }
  previous(){
    this.pageIndex--;
    if(this.operation=="default")
    this.APIgetCTSummary()
    else if(this.operation=="search")
    this.searchFunction()
  }
  next(){
    this.bookmarkArray.push(this.bookmark)
    this.pageIndex++

    if(this.operation=="default")
    this.APIgetCTSummary()
    else if(this.operation=="search")
    this.searchFunction()
  }
 



  downloadTemplates() {
    this.data = {
      "filterType": this.filterType,
      "param":this.param,
      "peid":this.entityId
    }
    var fileName;
    const now = new Date();
    const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
    this.ts.exportnonTTLTemplates(this.data).subscribe(r => {
      fileName = currentdat + 'TemplateRecords.csv';
      importedSaveAs(r, fileName)
      this.$modal.successModal({
        title: 'Template Records',
        msg: 'File has been downloaded Successfully'
      });

    });
  }
  

  onApplyFilter1(filterForm1) {
    console.log(filterForm1.value);
  }
  reset() {
    this.pageIndex=1
    this.data = {}
    this.APIgetCTSummary();
    this.filterType="all"

    this.showDropdown = false;
    this.fdate=null
    this.ldate=null

  }
  getEntityDetails(){
    let data = {  
        "entity_id": this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),     
      }
      this.ts.getContentEntityDetails(data)
        .subscribe(r => {
          try { 
              
  
              if(r[0].etype ==='P'){     
                this.industry_type="Private";
              
              }
               else if(r[0].etype =='G'){
                this.industry_type="Government";           
               } 
               else if(r[0].etype =='S'){
                this.industry_type="SEBI";           
               } 
               else if(r[0].etype =='O'){
                this.industry_type="Others";           
               } 
               else if(r[0].etype =='U'){
                this.industry_type="Unknown";           
               }                       
               this.entity_name=r[0].name
  
            }
          catch (e) {
           console.log("error",e)       
  
          }
        })
       }
  openDropdown(value) {
    this.form1.searchBy2=null
    this.form1.searchBy2 = "";
    if (value == "Operator") {
      this.showDropdown = true;
    }
    else {
      this.showDropdown = false;
    }
    this.form1.search="";
  } 
  
  
}
export class MyDataSource extends DataSource<any[]> { 

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}


